import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';
import { debounceTime, filter } from 'rxjs';

import { IBetslipRootState } from '../../../base/store/state';
import { BetslipNotificationActions } from '../betslip-notification.actions';
import { notificationSelector } from '../selectors';
import { BetslipNotificationUtils } from '../services/betslip-notification.utils';

@Component({
    selector: 'bs-betbuilder-notification',
    templateUrl: './betbuilder-notification.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./betbuilder-notification.component.scss'],
    standalone: false,
})
export class BetBuilderNotificationComponent implements OnInit {
    notification: string | null;
    private readonly destroyRef = inject(DestroyRef);

    constructor(
        private store: Store<IBetslipRootState>,
        private betslipNotificationUtils: BetslipNotificationUtils,
        private changeDetector: ChangeDetectorRef,
    ) {}

    ngOnInit(): void {
        this.store
            .select(notificationSelector)
            .pipe(debounceTime(100), filter(this.betslipNotificationUtils.isBetBuilderNotification), takeUntilDestroyed(this.destroyRef))
            .subscribe((notification) => {
                this.notification = notification.message;
                this.changeDetector.markForCheck();
            });
    }

    onCloseButtonClick(): void {
        this.store.dispatch(BetslipNotificationActions.clearMessage());
    }
}
